import {
  APP_BAR_HEIGHTS,
  componentZIndexes,
  makeStyles,
} from "@inductiveautomation/ws-components";

export const getLicenseStyles = makeStyles()((theme) => ({
  tabBarContainer: {
    position: "sticky",
    top: APP_BAR_HEIGHTS.default,
    zIndex: componentZIndexes.APP_BAR_Z_INDEX,

    background: theme.palette.neutral.white,
    borderTop: `1px solid ${theme.palette.neutral[30]}`,
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      top: APP_BAR_HEIGHTS.sm,
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",

    // NOTE: (2024-12-06) Noah Settersten => This limits the content height and allows it to scroll internally.
    maxHeight: `calc(100svh - ${APP_BAR_HEIGHTS.default}px)`,
    [theme.breakpoints.down("sm")]: {
      maxHeight: `calc(100svh - ${APP_BAR_HEIGHTS.sm}px)`,
    },
  },
  dataGridContainer: {
    padding: "0 1.5rem 3rem 1.5rem",
  },
  licenseDialogMainContent: {
    overflow: "auto",

    div: {
      height: "100%",
    },
  },
  eulaContainer: {
    "&&": {
      maxWidth: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "0",
    },
  },
  eulaFrame: {
    width: "100%",
    flex: "1 1 300px",
    maxHeight: "100%",
    margin: "0",
    padding: "0 3.5rem",
    border: "none",
  },
}));
